import { useCallback } from 'react';

//FYI: turns out useRef is not great here. useCallback is recommended. Reference: https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
export const useSortEventListenerFix = () =>
  useCallback((node: Element | null) => {
    // console.log('useSortEventListenerFix', node);
    const stopPropagationEventHandler = (event: Event) => {
      event.stopPropagation();
    };

    if (node) node.addEventListener('click', stopPropagationEventHandler);

    return () => {
      if (node) node.removeEventListener('click', stopPropagationEventHandler);
    };
  }, []);
